import {
  EMPTY_FUNCTION,
  EMPTY_LIST,
  MODAL_ID_DEFAULT,
} from '../../constants/common'
import { QA_NAME_CONFIRMATION_MINIMIZED_REPLACE_DRAFT_SAVED } from '../../constants/qa'
import { isDirtyForm } from '../../utils/formHelpers'
import { EntityActionTypeSelectOptionValue } from '../Entity'
import { ICON_CHEVRON_DIRECTION, IconChevron } from '../Icon'
import { MINIMIZED_MODAL_KEY } from '../Modal'

export const EMAIL_ITEM_ID_KEY = 'uuid'

export const EMAIL_TABLE_ROW_ACTIONS_WIDTH = 112

export const EMAIL_TABLE_ROW_ACTIONS_CONFIG = {
  itemIdKey: EMAIL_ITEM_ID_KEY,
}

export const EMAIL_NEED_RECONNECT = 'need_reconnect'

export const EMAIL_PRIVATE_TYPE = 'private'

export const EMAIL_NO_REPLY_PREFIXES = ['noreply', 'no-reply', 'do-not-reply']

export const EMAIL_SYMBOL_MAX_COUNT = 255

export const EMAIL_ACCOUNT_TYPE_PRIVATE = 'own'

export const EMAIL_ACCOUNT_TYPE_CORPORATE = 'corporate'

export const EMAIL_ACCOUNT_TYPE_SHARED = 'shared'

export const EMAIL_ACCOUNTS_API_PAGE_SIZE = 50

export const EMAIL_TABLE_ROW_MESSAGE_STATUS_ID = {
  error: 'error',
  sending: 'sending',
}

export const EMAIL_MINIMIZED_REPLACE_CONFIRMATION = {
  description: 'Modal.MinimizedEmailDraftSavedConfirmationTextKey',
  qaName: QA_NAME_CONFIRMATION_MINIMIZED_REPLACE_DRAFT_SAVED,
}

export const QA_NAME_CREATE_EMAIL = 'addNewEmail'

export const EMAIL_FORM_CONTEXT_DEFAULT_VALUE = {
  blackList: EMPTY_LIST,
  getIsDirty: isDirtyForm,
  isFullScreen: false,
  setBlackList: blackList => void blackList,
  setModal: modal => void modal,
  onCloseModal: EMPTY_FUNCTION,
  onResize: EMPTY_FUNCTION,
}

export const EMAIL_MESSAGE_API_URL = 'api/email-message/'

export const EMAIL_THREAD_API_URL = 'api/email-thread/'

export const EMAIL_PROFILE_WIDGET_NAME_AI_SUMMARY = 'email_summary'

export const EMAIL_PROFILE_WIDGET_NAME_FILES = 'files'

export const EMAIL_ACTION_ATTACH_REQUEST = 'attach_service_request'

export const EMAIL_ACTION_CREATE_SERVICE_REQUEST = 'create_service_request'

export const EMAIL_ACTION_VIEW_ENTIRE_MESSAGE = 'view_entire_message'

export const EMAIL_REPLY_FORM_WYSIWYG_CLASSNAME_HIDE_QUOTED_HISTORY =
  'hide-quoted-history'

export const EMAIL_REPLY_FORM_SHOW_CONVERSATION_BUTTON_CARET_SCROLL_MARGIN = 64

export const EMAIL_ACTION_COPY_TO = 'copy_to_entity_profile'

export const EMAIL_ACTION_COPY_TO_DELETE = 'delete_copy_to_entity_profile'

export const EMAIL_REALTIME_EVENT = {
  MessageCompleted: 'message_completed',
}

export const EMAIL_MESSAGE_COMPLETED_TABLE_RELOAD = 'reload'

export const EMAIL_ACCOUNT_TYPE_DESCRIPTION_KEYS = {
  [EMAIL_ACCOUNT_TYPE_CORPORATE]: 'Email.CorporateDescriptionKey',
  [EMAIL_ACCOUNT_TYPE_SHARED]: 'Email.SharedDescriptionKey',
  [EMAIL_PRIVATE_TYPE]: 'Email.PrivateDescriptionKey',
}

export const EMAIL_MESSAGE_PROFILE_ACTION_SERVICE_REQUESTS_OPTIONS =
  'service_requests_options'

export const EMAIL_THREAD_PROFILE_ACTION_COLLAPSE_ALL_MESSAGES = 'collapse_all'

export const EMAIL_THREAD_PROFILE_ACTION_EXPAND_ALL_MESSAGES = 'expand_all'

export const EMAIL_RECIPIENT_OPTION_ID_SEPARATOR = '::'

export const EMAIL_ACTION_ADD_NOTE = 'add_note'

export const EMAIL_ACTION_ARCHIVE_ITEM = 'archive_item'

export const EMAIL_ACTION_ARCHIVE_MASS = 'archive_mass'

export const EMAIL_ACTION_ATTACH_REQUEST_MASS = 'attach_service_request_mass'

export const EMAIL_ACTION_COPY_TO_ARCHIVE_ITEM = 'copy_to_archive'

export const EMAIL_ACTION_COPY_TO_ARCHIVE_MASS = 'copy_to_archive_mass'

export const EMAIL_ACTION_EDIT_LABELS_ITEM = 'edit_labels_item'

export const EMAIL_ACTION_EDIT_LABELS_MASS = 'edit_labels_mass'

export const EMAIL_EDIT_LABELS_ITEM_ACTION_TYPES = [
  EntityActionTypeSelectOptionValue.Add,
  EntityActionTypeSelectOptionValue.Edit,
  EntityActionTypeSelectOptionValue.RemoveAll,
]

export const EMAIL_ACTION_MARK_AS_READ_ITEM = 'mark_as_read_item'

export const EMAIL_ACTION_MARK_AS_READ_MASS = 'mark_as_read_mass'

export const EMAIL_ACTION_MARK_AS_STARRED_ITEM = 'mark_as_starred'

export const EMAIL_ACTION_MARK_AS_STARRED_MASS = 'mark_as_starred_mass'

export const EMAIL_ACTION_MARK_AS_UNREAD_ITEM = 'mark_as_unread_item'

export const EMAIL_ACTION_MARK_AS_UNREAD_MASS = 'mark_as_unread_mass'

export const EMAIL_ACTION_MARK_AS_UNSTARRED_ITEM = 'mark_as_unstarred'

export const EMAIL_ACTION_MARK_AS_UNSTARRED_MASS = 'mark_as_unstarred_mass'

export const EMAIL_ACTION_OPEN_IN_NEW_TAB = 'open_in_new_tab'

export const EMAIL_ACTION_RESTORE_ITEM = 'restore_item'

export const EMAIL_ACTION_RESTORE_MASS = 'restore_mass'

export const EMAIL_TABLE_MASS_ACTION_NAMES = {
  [EMAIL_ACTION_ARCHIVE_ITEM]: 'archive',
  [EMAIL_ACTION_ARCHIVE_MASS]: 'archive',
  [EMAIL_ACTION_ATTACH_REQUEST_MASS]: 'attach_to_request',
  [EMAIL_ACTION_COPY_TO_ARCHIVE_ITEM]: 'copy_to_archive',
  [EMAIL_ACTION_COPY_TO_ARCHIVE_MASS]: 'copy_to_archive',
  [EMAIL_ACTION_EDIT_LABELS_ITEM]: 'update_labels',
  [EMAIL_ACTION_EDIT_LABELS_MASS]: 'update_labels',
  [EMAIL_ACTION_MARK_AS_READ_ITEM]: 'mark_as_read',
  [EMAIL_ACTION_MARK_AS_READ_MASS]: 'mark_as_read',
  [EMAIL_ACTION_MARK_AS_STARRED_ITEM]: 'mark_as_starred',
  [EMAIL_ACTION_MARK_AS_STARRED_MASS]: 'mark_as_starred',
  [EMAIL_ACTION_MARK_AS_UNREAD_ITEM]: 'mark_as_unread',
  [EMAIL_ACTION_MARK_AS_UNREAD_MASS]: 'mark_as_unread',
  [EMAIL_ACTION_MARK_AS_UNSTARRED_ITEM]: 'mark_as_unstarred',
  [EMAIL_ACTION_MARK_AS_UNSTARRED_MASS]: 'mark_as_unstarred',
  [EMAIL_ACTION_RESTORE_ITEM]: 'restore',
  [EMAIL_ACTION_RESTORE_MASS]: 'restore',
}

export const EMAIL_TABLE_MODALS_CONFIG = {
  setEmailFormModal: {
    closer: 'closeEmailFormModal',
    id: MINIMIZED_MODAL_KEY.EMAIL_FORM,
  },
  setModal: { closer: 'closeModal', id: MODAL_ID_DEFAULT },
}

export const EMAIL_PROFILE_ACTION_ADD_NOTE = 'add_note'

export const EMAIL_PROFILE_ACTION_MARK_AS_IMPORTANT = 'mark_as_important'

export const EMAIL_PROFILE_ACTION_MARK_AS_UNIMPORTANT = 'mark_as_unimportant'

export const EMAIL_PROFILE_ACTION_ARCHIVE = 'archive'

export const EMAIL_PROFILE_ACTION_RESTORE = 'restore'

export const EMAIL_PROFILE_ACTION_DOWNLOAD_FILES = 'download_files'

export const EMAIL_PROFILE_ACTION_MESSAGE_RESEND = 'resend'

export const EMAIL_PROFILE_ACTION_REPLY = 'reply'

export const EMAIL_PROFILE_ACTION_REPLY_ALL = 'reply_all'

export const EMAIL_PROFILE_ACTION_FORWARD = 'forward'

export const EMAIL_PROFILE_ACTION_MARK_AS_UNREAD = 'mark_as_unread_item'

export const EMAIL_PROFILE_ACTION_PRINT = 'print'

export const EMAIL_PROFILE_NAVIGATION_STATE_KEY = 'emailProfileNavigation'

export const EMAIL_PROFILE_NAVIGATION_PREVIOUS_ICON_PROPS = {
  Icon: IconChevron,
  iconProps: { direction: ICON_CHEVRON_DIRECTION.LEFT },
}

export const EMAIL_PROFILE_NAVIGATION_NEXT_ICON_PROPS = {
  Icon: IconChevron,
  iconProps: { direction: ICON_CHEVRON_DIRECTION.RIGHT },
}
